<template>
  <div>
    <WdsHeading as="div" type="title2">
      {{ title }}
    </WdsHeading>
    <div class="!tw-mt-[4px] !tw-mb-[32px]">
      <WdsText v-for="(subtitle, i) in subtitles" :key="i" class="!tw-mb-[10px]" large secondary>
        {{ subtitle }}
      </WdsText>
    </div>
    <WdsStack v-for="(benefit, i) in benefits" :key="i" align-top class="!tw-mb-[24px]">
      <WdsIconCheckmark />
      <WdsText class="!tw-ml-[10px]" large>
        {{ benefit }}
      </WdsText>
    </WdsStack>
  </div>
</template>

<script>
import { WdsHeading, WdsIconCheckmark, WdsStack, WdsText } from '@worksome/wds-components'

export default {
  name: 'LeftTeaser',
  components: {
    WdsHeading,
    WdsIconCheckmark,
    WdsStack,
    WdsText,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitles: {
      type: Array,
      required: true,
    },
    benefits: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.wds-icon-svg {
  margin-top: 4px;
}
</style>
